import React from 'react';
import { CustomColumns, CustomColumnsBaseProps } from './CustomColumns';
import { CustomColumnsDragAndDrop } from './CustomColumnsDragAndDrop';
import { setCustomColumnsState } from '../../state/initCustomColumns';

export interface CustomColumnsFullProps extends CustomColumnsBaseProps {}

export function CustomColumnsFull(props: CustomColumnsFullProps) {
  return <CustomColumns {...props} />;
}

CustomColumnsFull.setCustomColumnsState = setCustomColumnsState;
CustomColumnsFull.dragAndDrop = CustomColumnsDragAndDrop;
CustomColumnsFull.displayName = 'CustomColumns';
